module.exports = __webpack_public_path__ + "static/media/303ButtonLabel--random.6d347cb2.svg";